import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { CmsConfig, ConfigModule, I18nModule } from '@spartacus/core';
import { IconModule } from '@spartacus/storefront';
import { SharedModule } from 'src/app/shared/shared.module';
import { ShimanoPaginationModule } from '../pagination/pagination.module';
import { SortingModule } from '../sorting/sorting.module';
import { TooltipTextModule } from '../tooltip-text/tooltip-text.module';
import { DealerListDetailsComponent } from './dealer-list/dealer-list-details/dealer-list-details.component';
import { DealerListComponent } from './dealer-list/dealer-list.component';
import { DealerSelectionListComponent } from './dealer-selection-list.component';

@NgModule({
  imports: [
    CommonModule,
    I18nModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatIconModule,
    MatTooltipModule,
    IconModule,
    ShimanoPaginationModule,
    FormsModule,
    ShimanoPaginationModule,
    SortingModule,
    SharedModule,
    NgbDropdownModule,
    TooltipTextModule,
    ConfigModule.withConfig({
      cmsComponents: {
        DealerSelectionListComponent: {
          component: DealerSelectionListComponent,
        },
        DealerSelectionListShipToComponent: {
          component: DealerSelectionListComponent,
        },
      },
    } as CmsConfig),
  ],
  declarations: [DealerSelectionListComponent, DealerListComponent, DealerListDetailsComponent],
  // entryComponents: [DealerSelectionListComponent],
  exports: [DealerSelectionListComponent],
})
export class DealerSelectionListModule {}
